import ApiConstants from '../../constants/ApiConstants';
import xhr from './xhr';

const TutorApiUtils = {
  fetchTutors(timeZone) {
    const query = `?time_zone=${timeZone}`;
    return xhr(ApiConstants.FetchTutors + query);
  },

  fetchTutorIds(timeZone) {
    return xhr(`${ApiConstants.FetchTutors}/ids`);
  },
};

export default TutorApiUtils;
